import { useEffect, useState } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { fetchAuthSession } from "aws-amplify/auth";

export function useAuthInfo() {
  const { user, authStatus } = useAuthenticator((ctx) => [
    ctx.user,
    ctx.authStatus,
  ]);

  const [userGroups, setUserGroups] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function load() {
      setLoading(true);

      const fromAttributes = user?.attributes?.email;
      const fromUsername = user?.username ?? user?.userId;
      if (mounted) setEmail(fromAttributes ?? fromUsername ?? "");

      try {
        const session = await fetchAuthSession();
        const tokenGroups =
          session?.tokens?.accessToken?.payload?.["cognito:groups"] ?? [];

        const idEmail = session?.tokens?.idToken?.payload?.email;
        const accessEmail = session?.tokens?.accessToken?.payload?.email;
        const tokenEmail = idEmail ?? accessEmail;

        if (mounted) {
          setUserGroups(Array.isArray(tokenGroups) ? tokenGroups : []);
          if (tokenEmail) setEmail(tokenEmail);
        }
      } catch (err) {
        if (mounted) setUserGroups([]);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (authStatus === "authenticated") {
      load();
    } else {
      setUserGroups([]);
      setEmail("");
      setLoading(authStatus === "configuring" || authStatus === "loading");
    }

    return () => {
      mounted = false;
    };
  }, [user, authStatus]);

  const ready = authStatus === "authenticated" && !loading;

  return { user, email, userGroups, loading, ready, authStatus };
}
